import {Component, Inject} from "@angular/core";
import {FelloDashboardOrigin, FelloOfferJourneyType, FelloVisitorVariables} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {GlobalTrackingEventService, TrackedEvents} from "fello-common";

export interface HearAboutUsOption {
  name: string;
  value: string;
}

const ALL_HEAR_ABOUT_US_OPTIONS: HearAboutUsOption[] = [
  {
    name: "Search Engine (Google, Bing etc.)",
    value: "Search Engine (Google, Bing etc.)"
  },
  {
    name: "Social media",
    value: "Social media"
  },
  {
    name: "Family or friend referral",
    value: "Family or friend referral"
  },
  {
    name: "Agent referral",
    value: "Agent referral"
  },
  // {
  //   name: "Billboard",
  //   value: "Billboard"
  // },
  {
    name: "Yard sign",
    value: "Yard sign"
  },
  {
    name: "Streaming / Podcast",
    value: "Streaming / Podcast"
  },
  {
    name: "Radio",
    value: "Radio"
  },
  {
    name: "TV / Streaming",
    value: "TV / Streaming"
  },
  {
    name: "Email",
    value: "Email"
  },
  {
    name: "Postcard / Mail",
    value: "Postcard / Mail"
  }
];

const TURBO_HEAR_ABOUT_US_OPTIONS: HearAboutUsOption[] = [
  {
    name: "Agent referral",
    value: "Agent referral"
  },
  {
    name: "Fello representative",
    value: "Fello representative"
  },
  {
    name: "Geopoint",
    value: "Geopoint"
  }
];

@Component({
  selector: "app-que-hear-about-us",
  templateUrl: "./que-hear-about-us.component.html",
  styleUrls: ["./que-hear-about-us.component.scss"]
})
export class QueHearAboutUsComponent extends QuestionCardDirective {
  howDidYouHear: string;
  hearAboutUsOptions: HearAboutUsOption[] = ALL_HEAR_ABOUT_US_OPTIONS;
  isTurboJourney = false;

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private globalTrackingEventService: GlobalTrackingEventService
  ) {
    super(offerJourneyService, taskId);
    this.howDidYouHear = this.offerJourney.vars.howDidYouHear ?? "";
    this.hearAboutUsOptions = this.offerJourney.origin === FelloDashboardOrigin.T ? TURBO_HEAR_ABOUT_US_OPTIONS : ALL_HEAR_ABOUT_US_OPTIONS;
    this.isTurboJourney = this.offerJourney.origin === FelloDashboardOrigin.T;
  }

  submit(howDidYouHear: string): void {
    const vars: FelloVisitorVariables = {
      howDidYouHear: howDidYouHear
    };
    this.offerJourneyService
      .pushOfferJourneyTask(this.taskId, vars)
      .subscribe(() =>
        this.globalTrackingEventService.trackCustomEvent(
          this.offerJourney.journeyType === FelloOfferJourneyType.LWF
            ? TrackedEvents.LIST_WITH_AGENT_REQUESTED
            : TrackedEvents.INSTANT_OFFER_REQUESTED
        )
      );
  }
}
